/** 프로필·사이드바 사진: VIEW/편집 키가 달라도 blob/data 미리보기 URL을 찾기 위한 보조 키 */
export const PROFILE_LOCAL_BLOB_FALLBACK_KEYS = ['profile_uid', 'profile_photo', 'photo_url', 'photoUrl'];

const PROFILE_SIDEBAR_KEYS_NORM = new Set(['profileuid', 'profilephoto', 'photourl']);

export function normalizeProfileBlobLookupKey(key) {
  if (!key || typeof key !== 'string') return '';
  return key.replace(/[\s-]+/g, '_').replace(/_+/g, '').toLowerCase();
}

/**
 * @param {Record<string, string>|undefined|null} localMap — 필드 key → blob:/data:image…
 * @param {string|undefined} fieldKey — 현재 레이아웃 필드 key
 * @returns {string} 없으면 ''
 */
export function pickProfileLocalPreviewUrl(localMap, fieldKey) {
  if (!localMap || typeof localMap !== 'object') return '';
  const tryKey = (k) => {
    if (!k) return '';
    const v = localMap[k];
    if (typeof v !== 'string') return '';
    const t = v.trim();
    if (!t) return '';
    if (t.startsWith('blob:') || t.startsWith('data:image')) return t;
    return '';
  };

  let b = tryKey(fieldKey);
  if (b) return b;

  for (const k of PROFILE_LOCAL_BLOB_FALLBACK_KEYS) {
    b = tryKey(k);
    if (b) return b;
  }
  for (const k of Object.keys(localMap)) {
    if (PROFILE_SIDEBAR_KEYS_NORM.has(normalizeProfileBlobLookupKey(k))) {
      b = tryKey(k);
      if (b) return b;
    }
  }
  return '';
}
